<template>
<div id="app">

  <transition name="router-transition" mode="out-in">
    <div class="menu-wrapper" v-if="shouldNavBeVisible">
      <div class="logo-top  sine-nav">
        <img :src="logoWhiteSrc" alt="">
      </div>
      <div @click="handeMobileMenu()" v-if="this.$root.isMobile" class="mobile-menu-button">
        {{mobileMenuOpen? 'Close' : 'Menu'}}
      </div>
    </div>
  </transition>

  <transition name="router-transition" mode="out-in">
    <div ref="nav" id="nav-bottom" v-if="shouldNavBeVisible">
      <transition name="router-transition">
        <menuComponent v-if="!this.$root.isMobile"></menuComponent>
        <menuComponent v-else v-show="mobileMenuOpen"></menuComponent>
      </transition>
    </div>
  </transition>

  <div>
    <transition name="rt" mode="out-in">
      <router-view :key="this.$route.name">
      </router-view>
    </transition>
  </div>

</div>
</template>

<script>
import menuComponent from '@/components/menu.vue';



export default {
  data() {
    return {
      cablesLoaded: false,
      logoWhiteSrc: require('@/assets/logo.png'),
      navVisibilityOverride: false,
      mobileMenuOpen: false
    }
  },
  components: {
    menuComponent
  },
  computed: {
    shouldNavBeVisible() {
      var check = this.$route.name == 'start' || this.$route.name == 'journey' || this.navVisibilityOverride == true
      if (check) {
        document.querySelector("html").classList.add("disable-scrollbars");
      } else {
        document.querySelector("html").classList.remove("disable-scrollbars");

      }
      return !check
    }
  },
  methods: {
    handeMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (this.mobileMenuOpen) {
        this.$options.disableBodyScroll(this.$refs.nav);
      } else {
        this.$options.enableBodyScroll(this.$refs.nav);
      }
    }
  },
  mounted() {
    this.$root.$on('navVisibilityOverride', (bool) => this.navVisibilityOverride = bool);
    this.$root.$on('mobileMenuOpen', (bool2) => {
      this.handeMobileMenu()
    });
  },
  created() {
    if (this.$root.isMobile) {
      this.$options.bodyScrollLock = require('body-scroll-lock')
      this.$options.disableBodyScroll = this.$options.bodyScrollLock.disableBodyScroll;
      this.$options.enableBodyScroll = this.$options.bodyScrollLock.enableBodyScroll;
    }
  }
}
</script>

<style lang="scss">
.logo-top {
    width: 100%;
    text-align: center;
    position: fixed;
    top: 0;
    z-index: 9;
    padding-top: 5vh;
    img {
        max-height: 10vh;
    }
}

.styled-button {
    margin: 2rem;
    transition: transform 0.3s ease;
    border: 2px solid $red;
    // padding: 2rem;
    border-radius: 1em;
    color: $red;
    display: inline-block;
    /* background: black; */
    filter: drop-shadow(0px 0px 3px red) drop-shadow(0px 0px 7px black);
    padding: 0 1em 5px;
    cursor: pointer;
    &:hover {
        transform: translateY(-.5rem);
    }
}
.disable-scrollbars {
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
    &::-webkit-scrollbar {
        width: 0;
        background: transparent;
        /* Chrome/Safari/Webkit */
    }
}
#app {
    // font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.5rem;
    // height: 100%;
    // min-height: 100%;
    // background: black;
    a,
    a:active,
    a:visited {
        color: $red;
        text-decoration: none;
    }
    #nav-bottom {
        nav {

            position: fixed;
            font-size: 1.5em;
            bottom: 0;
            right: 0;
            z-index: 12;
            display: flex;
            justify-content: center;
            align-items: center;
            color: $red;
            width: 100%;
            padding-bottom: 1em;
            .nav-button a {
                margin: 1em;
                transition: border-color 0.3s ease, color 0.3s ease;
                border: 2px transparent solid;
                border-radius: 1em;
                /* background: black; */
                filter: drop-shadow(0px 0px 3px red) drop-shadow(0px 0px 7px black);
                padding: 0 1em 5px;
                cursor: pointer;
                // border-radius: 1em;
                // border: 2px solid white;
            }
            .nav-button .router-link-exact-active {
                border: 2px $red solid;

            }
        }

    }
}

.loading-screen {
    text-align: center;
    z-index: 1;
    pointer-events: none;
    position: fixed;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    align-content: center;
    transition: color 1s ease;
    padding: 0 2rem;

    .loading-parts {
        width: 100%;
    }
    span {
        pointer-events: auto;
        cursor: pointer;
    }
    .span-link {
        border-bottom: 1px solid black;

    }
}
.mobile-menu-button {
    // position: fixed;
    // bottom: 0;
    height: max-content;
    text-align: center;
    // left: 50%;
    // transform: translate(-50%);
    // margin-bottom: 1em;
    border: 2px $red solid;
    border-radius: 2rem;
    filter: drop-shadow(0px 0px 3px red) drop-shadow(0px 0px 7px black);
    padding: 0 1em 5px;
    cursor: pointer;
    z-index: 2;
    font-size: 1.5em;
    color: $red;
}
@media screen and (max-width: 600px) {
    .menu-wrapper {
        display: grid;
        position: fixed;
        z-index: 15;
        padding: 2rem;
        grid-gap: 6rem;
        align-items: center;
        grid-template-columns: 1fr 1fr;
        background: linear-gradient(to bottom, rgba(0,0,0,.9) 0%,rgba(0,0,0,0) 89%,rgba(0,0,0,0) 100%);
    }

    #app #nav-bottom nav {
        overscroll-behavior: contain;
        position: fixed;
        height: 100%;
        padding: 40% 0;
        font-size: 1.5em;
        text-align: center;
        display: grid;
        grid-gap: 0 0;

        width: 100%;
        background: black;
    }
    .logo-top {
        width: 100%;
        animation: none !important;
        text-align: center;
        position: relative;
        padding-top: 0;
        img {
            max-height: 10vh;
        }
    }
}
</style>
